import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 20, height = 20, color = 'currentColor', customClass = '' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' class={customClass}>
  <path d='M7.50013 13.475L4.02513 9.99999L2.8418 11.175L7.50013 15.8333L17.5001 5.83333L16.3251 4.65833L7.50013 13.475Z' fill={color} />
</svg>
